import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import MatterStage from '../../entities/matterStage';
import Matter from '../../entities/matter';

/*
 * Delete/nullify anywhere this matterStage is used in other entities
 *
 * @param {MatterStage} matterStage
 */
export function deleteMatterStage(matterStage: MatterStage, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = matterStage.id;
    }
    /* Simple delete usages */
        
    store.getState().matters
        .getMappingFor('matterStageId', matterStage.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.currentStageId = null;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    /* Remove the actual matterStage */
    matterStage.status = 'D';
    matterStage.addedOn = newHRTimestamp();
    matterStage.addedBy = getCurrentUserId();
    matterStage.importSource = targetImportSource;
    matterStage.importId = mergeId;
    store.dispatch(Actions.MatterStageActions.removeMatterStageQueue(matterStage));
    
}

/*
 * Replace anywhere this matterStage is used in other entities.
 *
 * @param {MatterStage} matterStage
 * @param {MatterStage} replaceWith
 * @return {MatterStage} - MatterStage will have refs stripped away
 */
export function replaceMatterStage(matterStage: MatterStage, replaceWith: MatterStage, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = matterStage.id;
    }
    /* Simple replace usages */
        
    store.getState().matters
        .getMappingFor('matterStageId', matterStage.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.currentStageId = replaceWith.id;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    return matterStage;
}

/*
 * Determine the impact of deleting this matterStage from other entities
 *
 * @param {MatterStage} matterStage
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactMatterStage(matterStage: MatterStage) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const matterCurrentStageIdImpact = state.matters
          .getMappingFor('matterStageId', matterStage.id)
          .filter(matter => matter.status !== 'D');

    matterCurrentStageIdImpact.forEach(() => impacts.push('matters'));

    return util.countDistinct(impacts);
}